import React, { useEffect } from "react";
import { connect } from "react-redux";
import setCoverPresent from '../redux/actions';
import CaseStudyPage from '../components/CaseStudyPage';
import ProjectModel from '../models/ProjectModel';

function YoungGuns({ dispatch }) {
  useEffect(() => {
    dispatch(setCoverPresent('no'));
  }, []);

  const model = {
    ...ProjectModel.YoungGuns,
    splitScreen: true,
    sections: [
      {
        type: 'full',
        src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-1.mp4',
      },
      {
        type: 'half',
        images: [
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-2.jpg', caption: 'Foldout Mailer (Front)' },
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-3.jpg', caption: 'Foldout Mailer (Back)' },
        ],
      },

      {
        type: 'half',
        images: [
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-13.gif', caption: 'Social' },
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-14.gif', caption: 'Social' },
        ],
      },
      {
        type: 'third',
        cols: 2,
        rowGap: '12px',
        images: [
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-4.jpg' },
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-5.jpg' },
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-6.jpg' },
          { src: 'img/project-page/young-guns/YoungGuns-MariaChimishkyan-7.jpg' },
        ],
      },
      {
        type: 'color-palette',
        perRow: 4,
        colors: [
          { name: 'Violet', pantone: '2655 C', cmyk: '—', rgb: '—', hex: '#8576D1' },
          { name: 'Pink',   pantone: '190 C',  cmyk: '—', rgb: '—', hex: '#FF89B0' },
          { name: 'Coral',  pantone: '1635 C', cmyk: '—', rgb: '—', hex: '#FF9E86' },
          { name: 'Yellow', pantone: '120 C',  cmyk: '—', rgb: '—', hex: '#FCE988' },
          { name: 'Peach',  pantone: '1555 C', cmyk: '—', rgb: '—', hex: '#FFDAC7', span: 2 },
          { name: 'White',  pantone: null,     cmyk: '—', rgb: '—', hex: '#FFFFFF', span: 2 },
        ],
      },
    ],
  };

  return <CaseStudyPage projectModel={model} />;
}

export default connect()(YoungGuns);
